import React, { StatelessComponent } from 'react';

type HeadingSize = 1 | 2 | 3 | 4 | 5 | 6;

/**
 * <Heading> props.
 */
interface IHeadingProps {
    /**
     * Size of the heading.
     * This are analogous to the <h1>...<h6> tags.
     */
    size: HeadingSize;
    /**
     * Add extra class names.
     */
    className?: string;
}

/**
 * A Heading component.
 */
export const Heading: StatelessComponent<IHeadingProps> = props => {
    const { size, className, children } = props;
    const Component = `h${size}` as 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
    return <Component className={className}>{children}</Component>;
};

Heading.defaultProps = {
    size: 1
};



// WEBPACK FOOTER //
// ./src/packages/components/lib/Heading/index.tsx